import * as core from '../../../../../../../core'
import * as jiraStatus from '../jira-status'

export const RESOURCE = {
  payload: {
    description: 'The Jira issue is complete',
    enumId: core.dms.models.Enum.Id.from({
      partialId: jiraStatus.RESOURCE.payload.partialId,
    }),
    id: 'Done',
    name: 'Done',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
